import { fmt, fmtMoney, qtyCols } from "@/lib/api";
import { TableCell, TableHead } from "@/components/ui/table";

export const QtyHeads = () => (<><TableHead className="text-right">Qté / pièce</TableHead><TableHead className="text-right">Quantité Kg/M</TableHead></>);

export const QtyCells = ({ item, sign = "", className = "" }) => {
  const { pieces, measure, munit } = qtyCols(item);
  return (<>
    <TableCell className={`text-right ${className}`}>{pieces != null && pieces !== 0 ? `${sign}${fmt(Math.abs(pieces))} pc` : "—"}</TableCell>
    <TableCell className={`text-right font-semibold ${className}`}>{measure != null ? `${sign}${fmt(Math.abs(measure))} ${munit}` : "—"}</TableCell>
  </>);
};

export const qtyText = (item) => {
  const { pieces, measure, munit } = qtyCols(item);
  const parts = [];
  if (pieces != null && pieces !== 0) parts.push(`${fmt(Math.abs(pieces))} pc`);
  if (measure != null) parts.push(`${fmt(Math.abs(measure))} ${munit}`);
  return parts.join(" · ") || "—";
};
